<mat-form-field
  class="app-filter-select"
  [ngClass]="styleClass"
  [ngStyle]="style"
  appearance="outline"
  [class.app-filter-select--open]="isOpen"
  subscriptSizing="dynamic"
  >
  <mat-select
    [id]="id"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [value]="value"
    [panelClass]="panelClasses"
    (selectionChange)="onMatSelectionChange($event)"
    (openedChange)="handleOpenedChange($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    >
    @if (selectedItemTemplate?.templateRef) {
      <mat-select-trigger>
        <ng-container
                *ngTemplateOutlet="
                    selectedItemTemplate.templateRef;
                    context: { $implicit: selectedOption, value: value, option: selectedOption }
                "
        ></ng-container>
      </mat-select-trigger>
    }

    <div class="app-filter-select__scroll">
      @if (filter) {
        <mat-option class="app-filter-select__search-option">
          @if (filterTemplate?.templateRef) {
            <div
              class="app-filter-select__search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              >
              <ng-container
                        *ngTemplateOutlet="
                            filterTemplate.templateRef;
                            context: { $implicit: options, options: options }
                        "
              ></ng-container>
            </div>
          } @else {
            <div
              class="app-filter-select__search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              >
              <i class="pi pi-search app-filter-select__filter-icon" aria-hidden="true"></i>
              <input
                matInput
                type="text"
                placeholder="Filter"
                [(ngModel)]="filterText"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="$event.stopPropagation()"
                />
              @if (filterText && filterText.length > 0) {
                <button
                  type="button"
                  class="app-filter-select__clear-btn"
                  (click)="filterText = ''"
                  aria-label="Clear filter"
                  >
                  <i class="pi pi-times" aria-hidden="true"></i>
                </button>
              }
            </div>
          }
        </mat-option>
      }

      @if (virtualScroll) {
        <cdk-virtual-scroll-viewport
          class="app-filter-select__viewport"
          [itemSize]="itemSizePx"
          [style.height.px]="viewportHeightPx"
          >
          <mat-option *cdkVirtualFor="let option of displayedOptions" [value]="getOptionValue(option)">
            @if (itemTemplate?.templateRef) {
              <ng-container
                                *ngTemplateOutlet="
                                    itemTemplate.templateRef;
                                    context: { $implicit: option, option: option }
                                "
              ></ng-container>
            } @else {
              {{ getOptionLabel(option) }}
            }
          </mat-option>
        </cdk-virtual-scroll-viewport>
      } @else {
        @for (option of displayedOptions; track option) {
          <mat-option [value]="getOptionValue(option)">
            @if (itemTemplate?.templateRef) {
              <ng-container
                            *ngTemplateOutlet="
                                itemTemplate.templateRef;
                                context: { $implicit: option, option: option }
                            "
              ></ng-container>
            } @else {
              {{ getOptionLabel(option) }}
            }
          </mat-option>
        }
      }

    </div>

    @if (footerTemplate?.templateRef) {
      <div
        class="app-filter-select__footer"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        >
        <ng-container
                *ngTemplateOutlet="
                    footerTemplate.templateRef;
                    context: { options: options }
                "
        ></ng-container>
      </div>
    }
  </mat-select>

  @if (showClear && !disabled && !isValueEmpty) {
    <button
      matSuffix
      type="button"
      class="app-filter-select__suffix-clear"
      (click)="clear($event)"
      aria-label="Clear selection"
      >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
</mat-form-field>

